// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2qp7SYOfDQO8xaLvgPW35y","local":"_3GHvqg2sDrnt_ioIeif8R0"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/Authentication/ButtonLoginDev.scss
// module id = 724
// module chunks = 0